import { render, staticRenderFns } from "./FeedViewPush.vue?vue&type=template&id=5a5ba96a&scoped=true&"
import script from "./FeedViewPush.vue?vue&type=script&lang=js&"
export * from "./FeedViewPush.vue?vue&type=script&lang=js&"
import style0 from "./FeedViewPush.vue?vue&type=style&index=0&id=5a5ba96a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ba96a",
  null
  
)

export default component.exports